module.exports = __webpack_public_path__ + "img/1.428ff397.png";